export default [
  { id: 1, name: 'BMW', price: '200' },
  { id: 2, name: 'Apple', price: '100' },
  { id: 3, name: 'Twitter', price: '40' },
  { id: 4, name: 'Lexus', price: '300' }
]
